var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.373 198.14C185.632 195.77 198.512 179.048 196.142 160.791C193.773 142.533 177.05 129.654 158.792 132.024C140.534 134.393 127.653 151.115 130.023 169.373C132.393 187.63 149.115 200.509 167.373 198.14Z",
    fill: "#9B5DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.518 3H10.399C6.31261 3 3 6.31269 3 10.3991V316.518C3 320.605 6.31261 323.917 10.399 323.917H316.518C320.605 323.917 323.917 320.605 323.917 316.518V10.3991C323.917 6.31269 320.605 3 316.518 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.78 212.665C269.713 165.743 316.051 106.28 299.278 79.8511C282.505 53.4222 208.972 70.0353 135.039 116.958C61.105 163.88 14.7673 223.343 31.5405 249.772C48.3136 276.201 121.846 259.587 195.78 212.665Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.319 200.912C236.965 170.039 266.142 128.849 253.488 108.911C240.835 88.9731 191.142 97.8377 142.496 128.711C93.851 159.584 64.6738 200.774 77.3275 220.712C89.9811 240.65 139.674 231.785 188.319 200.912Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.518 3H10.399C6.31261 3 3 6.31269 3 10.3991V316.518C3 320.605 6.31261 323.917 10.399 323.917H316.518C320.605 323.917 323.917 320.605 323.917 316.518V10.3991C323.917 6.31269 320.605 3 316.518 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 324C252.142 324 324 252.142 324 163.5C324 74.8583 252.142 3 163.5 3C74.8584 3 3 74.8583 3 163.5C3 252.142 74.8584 324 163.5 324Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwExplorer);
export default __webpack_public_path__ + "static/media/dfw-Explorer.c1a81f98932cb483d24f1fb17826f843.svg";
export { ForwardRef as ReactComponent };